import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  patSearchParameters: {
    NuPat: "",
    nuProtocolo: "",
    nuOs: "",
    identificador: "",
    urtProcessante: "",
    sqSituacao: "",
    motivoBaixa: "",
    detalheBaixa: "",
    dtInicio: "",
    dtFim: "",
  },
  searchResults: [],
};

const patSearchSlice = createSlice({
  name: "patSearch",
  initialState,
  reducers: {
    salvarEstado(state, action) {
      state.patSearchParameters = { ...action.payload };
    },
    salvarResultados(state, action) {
      state.searchResults = action.payload;
    },
    reset: () => initialState,
  },
});

export const patSearchActions = patSearchSlice.actions;

export default patSearchSlice.reducer;
